import { api } from './api'

export const apiDriver = {
    getDrivers: (filter, page, size = 10) => {
        return api.post('web/drivers/filter', { filter, page, size })
    },

    exportDriver: (filter, page, size, fileName = 'Danh sách tài xế') => api.postExcel('web/export/drivers', { filter, page, size, fileName }),

    getCreateDriverOptions: () => api.get('web/drivers/create_driver_options'),

    getFilterDriverOptions: () => api.get('web/drivers/filter_driver_options'),

    createNewDriver: (params) => {
        return api.post('web/drivers/create_driver', { ...params })
    },

    updateDriver: (params) => {
        return api.put('web/drivers/update_driver', { ...params })
    },

    deleteDriver: (id) => {
        return api.delete(`web/drivers/delete_driver/${id}`)
    },
}
